import React from "react";
import NavBar from "../../NavBar"
import Footer from "../../Footer"
import datiCover from "../../../data/telefonoProdotti.json";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { useEffect } from "react";
import ScrollabileRiga from "../ScrollabileRiga";
import Selezione from "../Selezione"

export default function CoverVetriProtettivi(){

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    function tornaSopra(){
        document.body.scrollTop = 0; 
        document.documentElement.scrollTop = 0;
    }
    useEffect(() => {
            window.addEventListener("scroll",(e)=>{
            const bottone = document.getElementById("btnTop");
            if(window.scrollY===0){
                try {
                    bottone.classList.add("invisibile");
                } catch (error) {
                    return null;
                }
                
                
                setTimeout(() => {
                    try {
                        bottone.classList.add("invisibilePerDavvero")
                    } catch (error) {
                        return null;
                    }
                    
                }, "490");
                try {
                    bottone.classList.remove("visibile");
                } catch (error) {
                    return null;
                }
                
            }else{
                try {
                    bottone.classList.remove("invisibile");
                    bottone.classList.remove("invisibilePerDavvero");
                    bottone.classList.add("visibile");
                } catch (error) {
                    return null;
                }
                
            }
            
        });
        
    });
    
    const arrId=["In Generale","Modelli Cover","Modelli Vetri"]    

    return (
        <div className="coverBody wuXieKeJi">
            <button id="btnTop" onClick={()=>tornaSopra()}><FontAwesomeIcon icon={faArrowUp} /></button>
            <NavBar uno ="Prodotti" due="Informazioni" tre="Contattaci" one="/prodotti" two="/informazioni" three="/contattaci"/>
            <h1 className="titoloProdotti">Cover e Vetri Protettivi</h1>
            <Selezione arr={arrId}/>
            

            <div className="premessaProdotti">
                <p>A causa di un ecessivo numero di cover e vetri protettivi, qui mostriamo in dettaglio solo alcuni modelli.</p>
            </div>


            <div className="colonna telefoni">

                <ScrollabileRiga idTitolo="InGenerale" titolo="Custodie e Vetri Protettivi" idScroll1="1" idScroll2="2" dati={datiCover} tipo="cover" sottoTipo1="overView1" sottoTipo2="overView2" nomeDati="telefonoProdotti"/>
                
                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="ModelliCover" titolo="Modelli di Cover" idScroll1="3" idScroll2="4" dati={datiCover} tipo="cover" sottoTipo1="cover1" sottoTipo2="cover2" nomeDati="telefonoProdotti"/>

                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="ModelliVetri" titolo="Modelli di Vetri" idScroll1="5" idScroll2="6" dati={datiCover} tipo="cover" sottoTipo1="vetri1" sottoTipo2="vetri2" nomeDati="telefonoProdotti"/>

            </div>
            <Footer />
        </div>
    )
}